import { Link as RouterLink } from 'react-router-dom';

import { Button, Stack, Typography } from '@mui/material';

import ChannelTalkIcon from '@/assets/images/channel-talk/ChannelTalkIcon';
import { 플랜_라우터 } from '@/router/plan/routes';
import { useUserAuth } from '@/state/cookieContext';
import { ChannelTalkService } from '@/thirdparty/ChannelTalk/ChannelTalkInitialize';

/**
 * 사용가이드, 1:1 문의하기 버튼 섹션
 */
export const ButtonsSection = () => {
  const userAuth = useUserAuth();

  const isManager = userAuth?.roles.includes('ROLE_MANAGER') ?? false;

  return (
    <Stack direction="row" spacing={2}>
      <Button component={RouterLink} sx={{ px: '6px', py: 0.5, color: 'black' }} to={플랜_라우터.플랜요금.path}>
        <Typography variant="Body_Looko">서비스 요금</Typography>
      </Button>
      <Button
        sx={{ px: '6px', py: 0.5, color: 'black' }}
        href="https://marmalade-polonium-d4f.notion.site/Looko-AI-fe3485205ef9442290cf33b38db1bc8c"
        target="_blank"
      >
        <Typography variant="Body_Looko">동영상 가이드</Typography>
      </Button>
      <Button
        variant="contained"
        color="neutral"
        disableElevation={true}
        sx={{
          p: '4px 8px',
          bgcolor: '#E4F2FD',
          color: 'primary.main',
          '&:hover': {
            bgcolor: '#E4F2FD',
          },
        }}
        onClick={isManager ? undefined : onClickChannelTalk}
      >
        <Stack direction="row" alignItems="center" gap={0.5}>
          1:1 문의
          <ChannelTalkIcon />
        </Stack>
      </Button>
    </Stack>
  );
};

const onClickChannelTalk = () => {
  ChannelTalkService.showMessenger();
};
